module.exports = __webpack_public_path__ + "static/media/login_main_image.74056558.svg";